import { useRegisterSW } from "virtual:pwa-register/react";
import { Button } from "@mantine/core";
import { useEffect } from "react";
import { toast } from "sonner";

const AppUpdateModal = () => {
	const {
		needRefresh: [needRefresh, setNeedRefresh],
		updateServiceWorker,
	} = useRegisterSW({});

	// biome-ignore lint/correctness/useExhaustiveDependencies: it's not necessary
	useEffect(() => {
		needRefresh &&
			toast("새로운 업데이트가 있습니다", {
				action: (
					<Button
						size="sm"
						compact
						variant="filled"
						onClick={() => updateServiceWorker(true)}
						className="toast-update"
					>
						업데이트
					</Button>
				),
				cancel: (
					<Button
						ml="auto"
						size="sm"
						compact
						variant="default"
						onClick={() => setNeedRefresh(false)}
						className="toast-cancel"
					>
						다음에
					</Button>
				),
			});
	}, [needRefresh]);

	return null;
};

export default AppUpdateModal;
